<template>
  <div class="header-menus" ref="menu">
    <div class="col-header-logo">
      <a class="col-header-cell" @click="sendEvent('www')" :href="jumpUrls[0]"></a>
    </div>
    <div class="col-header-button" @click.stop="toggle()">
      <div class="header-col-bar" v-if="!show">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div v-else class="header-col-close"></div>
    </div>
    <a v-if="bulkOrder" :href="jumpUrls[1]" class="actions bulkOrder-actions">
      <span class="line"></span>
      <span class="link-bulkOrder">{{ $trans('大宗定购') }}<i></i></span>
      <span class="line"></span>
    </a>

    <transition name="collapse" @enter="enter" @after-enter="afterEnter" @leave="leave">
      <!-- v-if="show" -->
      <div @click="hideMenu" id="header-col-cover" v-if="show">
        <div class="header-col-nav">
          <!-- 原始菜单 -->
          <div class="header-col-group">
            <a
              class="col-first-a"
              v-for="item in menus"
              :key="item.name"
              @click.stop="proxyClick($event, item)"
              :class="{ 'col-active-link': groupArray[item.index] }"
            >
              <span class="first-menu">{{ item.name }}</span>
              <span v-if="item.children" class="header-right-p"><i class="header-right"></i></span>
            </a>
          </div>
          <!-- 有一级菜单 -->
          <div class="header-col-child" v-if="groupChildShow">
            <div v-for="child in groupChild" :key="child.name">
              <!-- 有二级菜单 -->
              <div v-if="child.children">
                <div class="header-col-title">
                  <div class="header-second-menu" :class="{ 'header-second-active': groupChildShowArray[child.index] }" @click.stop="childClick($event, child)">
                    {{ child.name }}
                    <p class="header-up-p" v-if="groupChildShowArray[child.index]"><i class="header-up"></i></p>
                    <p class="header-down-p" v-else><i class="header-down"></i></p>
                  </div>
                  <div class="header-third-menu" v-if="groupChildShowArray[child.index]">
                    <div v-for="child1 in groupChild1" :key="child1.name">
                      <a v-if="child1.label !== 'materials' || user" @click.stop="proxyClick($event, child1)">{{ child1.name }}</a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 没有二级菜单 -->
              <a class="col-no-third" v-else @click.stop="proxyClick($event, child)"
                ><div class="no-third-name">{{ child.name }}</div></a
              >
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
const i18n = {
  zh: {},
  en: {
    大宗定购: 'Bulk Order',
  },
};
export default {
  props: {
    locale: {
      type: String,
      default: 'en',
    },
    menus: {
      type: Array,
      required: true,
    },
    rightMenus: {
      type: Array,
      required: true,
    },
    jumpUrls: {
      type: Array,
      required: true,
    },
    user: {
      type: Boolean,
      default: false,
    },
    login: {
      type: Function,
      default: () => {},
    },
    logout: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      show: false,
      groupChildShow: false,
      groupChildShowArray: [],
      groupArray: [],
      groupChild: [],
      lastFirstMeun: 100,
      laseSecondMenu: 100,
      account: this.rightMenus.indexOf('account') > -1 ? true : false,
      bulkOrder: this.rightMenus.indexOf('bulkOrder') > -1 ? true : false,
      myCart: this.rightMenus.indexOf('myCart') > -1 ? true : false,
    };
  },
  watch: {
    show() {
      this.$emit('change', this.show);
    },
  },
  mounted() {
    document.addEventListener('click', this.close);
  },
  destroyed() {
    document.removeEventListener('click', this.close);
  },
  methods: {
    $trans(key) {
      let messages = i18n[this.locale];

      if (!messages) {
        messages = i18n.en;
      }

      return messages[key] || key;
    },
    toggle() {
      this.show = !this.show;
    },
    hideMenu() {
      this.show = false;
    },
    close(evt) {
      let node = evt.target;
      let menu = this.$refs.menu;
      while (node && node !== menu) {
        node = node.parentNode;
      }
      if (!node) {
        this.show = false;
      }
    },
    sendEvent(name) {
      if (this.sendEvent || window.sendEvent) {
        const sendEvent = this.sendEvent || window.sendEvent;
        sendEvent('头部', `bitmain-header-${name}`);
      }
    },
    // 点击原始菜单
    proxyClick(evt, item) {
      // 有一级菜单
      this.groupChildShow = false;
      this.groupArray = Array(this.menus.length).fill(false);
      if (item.children && item.children.length) {
        if (this.lastFirstMeun === item.index) {
          // 点击取消选中当前菜单
          this.groupChildShow = false;
          this.groupArray[item.index] = false;
          this.lastFirstMeun = 100;
        } else {
          this.groupChildShow = true;
          this.groupArray[item.index] = true;
          this.lastFirstMeun = item.index;
        }
        this.groupChild = item.children;
      } else {
        // 无一级菜单
        if (item.url) {
          if (item.label === 'parts' && !this.user) {
            window.location.href = this.jumpUrls[2] + '&service=' + item.url;
          } else {
            window.location.href = item.url;
          }
          this.sendEvent(item.label);
        } else {
          item.onClick(item);
        }
        this.groupChildShow = false;
        this.groupChildShow1 = false;
        this.show = false;
      }
    },
    // 点击一级菜单
    childClick(evt, item) {
      // 有二级菜单
      if (item.children && item.children.length) {
        this.groupChild1 = item.children;
        this.groupChildShowArray = Array(this.groupChild.length).fill(false);
        if (this.laseSecondMenu === item.index) {
          this.groupChildShowArray[item.index] = false;
          this.laseSecondMenu = 100;
        } else {
          this.groupChildShowArray[item.index] = true;
          this.laseSecondMenu = item.index;
        }
      } else {
        // 无二级菜单
        if (item.url) {
          location.href = item.url;
          this.sendEvent(item.label);
        } else {
          item.onClick(item);
        }
        this.groupChildShow = false;
        this.show = false;
      }
    },
    enter(element) {
      const width = getComputedStyle(element).width;

      element.style.width = width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const height = getComputedStyle(element).height;

      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      // Trigger the animation.
      // We use `setTimeout` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    leave(element) {
      const height = getComputedStyle(element).height;

      element.style.height = height;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      setTimeout(() => {
        element.style.height = 0;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.header-menus {
  user-select: none;
  cursor: pointer;
  margin: 16px 10px;
  -webkit-tap-highlight-color: transparent;
  -moz-tap-highlight-color: transparent;
  .col-header-logo {
    float: left;
    height: 100%;
    .col-header-cell {
      width: 140px;
      height: 17px;
      display: inline-block;
      background: url(./images/logo-black.png) no-repeat center center;
      background-size: cover !important;
    }
  }
  .col-header-button {
    float: right;
  }
  .actions {
    &.bulkOrder-actions {
      position: absolute;
      right: 36px;
      align-items: center;
      .line {
        display: none;
      }
      .link-bulkOrder {
        font-size: 14px;
        margin-top: 2px;
        i {
          display: inline-block;
          width: 18px;
          height: 18px;
          background: url(./images/ico-bulkOrder.png) no-repeat center center;
          background-size: contain;
          margin: 0 5px -4px 5px;
        }
      }
    }
  }
  .header-col-bar {
    i {
      display: block;
      width: 22px;
      height: 2px;
      margin: auto;
      background: #000;
      margin-top: 4px;
    }
  }
  .header-col-close {
    position: relative;
    width: 28px;
    // margin: 3px 0;
  }

  .header-col-close::before,
  .header-col-close::after {
    position: absolute;
    content: ' ';
    background-color: #000;
    left: 16px;
    width: 2px;
    height: 20px;
  }

  .header-col-close::before {
    transform: rotate(45deg);
  }

  .header-col-close::after {
    transform: rotate(-45deg);
  }
}
#header-col-cover {
  position: fixed;
  left: 0px;
  top: 50px;
  background: rgba(0, 0, 0, 0.5);
  width: 100%; /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  height: 100% !important;
  filter: alpha(opacity=100); /*设置透明度为100%*/
  opacity: 1; /*非IE浏览器下设置透明度为100%*/
  display: block;
  z-index: 999;
}
.header-col-nav {
  display: flex;
  width: 100%;
  .header-col-group {
    flex: 5;
    display: inline-block;
    background: #f2f4f6;
    padding: 30px 0 38px;
    .col-first-a {
      font-size: 12px;
      position: relative;
    }
    .first-menu {
      display: inline-block;
      padding-right: 17px;
      white-space: nowrap;
    }
    i {
      border: solid #3371ff;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
    }
    .header-right-p {
      display: inline-block;
      float: right;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 28px;
    }
    .header-right {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
  }
  .header-col-child {
    flex: 6;
    display: inline-block;
    background-color: #fff;
    padding: 30px 0 38px;
    .col-no-third {
      padding: 0 20px;
      .no-third-name {
        width: 100%;
        padding: 16px 0;
        border-bottom: 1px solid #e1e1e1;
      }
    }
  }
  .header-col-title {
    // padding: 15px 30px;
    padding: 0px 20px;
    // 二级菜单
    .header-second-menu {
      padding: 16px 0;
      font-size: 12px;
      font-weight: 500;
      border-bottom: 1px solid #e1e1e1;
      p {
        display: inline-block;
        float: right;
        padding-right: 5px;
      }
      .header-up-p {
        transform: translateY(3px);
        -webkit-transform: translateY(3px);
      }
      .header-down-p {
        transform: translateY(-3px);
        -webkit-transform: translateY(-3px);
      }
      i {
        border: solid #3371ff;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 3px;
      }
      .header-up {
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
      .header-down {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }
    .header-second-active {
      border-bottom: none;
    }
    .header-third-menu {
      border-bottom: 1px solid #e1e1e1;
    }
    // 三级菜单样式
    a {
      padding: 13px 10px;
      font-size: 10px;
    }
  }
  @media (max-width: 768px) {
    top: 50px;
  }
  z-index: 1000;
  text-align: left;
  a {
    display: block;
    padding: 15px 30px;
    font-size: 12px;
    color: #000;
    font-weight: 500;
  }
  .col-active-link {
    background-color: #fff;
    border-left: 6px solid #3371ff;
    padding: 15px 23px;
    .header-right-p {
      display: none;
    }
  }
}
</style>
